declare namespace $ {

	type $mol_view__sub_shm_hotkey_editor_1 = $mol_type_enforce<
		ReturnType< $shm_hotkey_editor['bubble_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hotkey_editor_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hotkey_editor_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hotkey_editor_4 = $mol_type_enforce<
		ReturnType< $shm_hotkey_editor['configure_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_shm_hotkey_editor_5 = $mol_type_enforce<
		ReturnType< $shm_hotkey_editor['configure_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hotkey_editor_6 = $mol_type_enforce<
		ReturnType< $shm_hotkey_editor['configure'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hotkey_editor_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_shm_hotkey_editor_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_shm_hotkey_editor_9 = $mol_type_enforce<
		ReturnType< $shm_hotkey_editor['remove_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hotkey_editor_10 = $mol_type_enforce<
		ReturnType< $shm_hotkey_editor['remove'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hotkey_editor_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_pop_bubble__content_shm_hotkey_editor_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_bubble['content'] >
	>
	type $mol_pop_bubble__style_shm_hotkey_editor_13 = $mol_type_enforce<
		({ 
			'positionAnchor': ReturnType< $shm_hotkey_editor['anchor'] >,
		})  & ReturnType< $mol_pop_bubble['style'] >
		,
		ReturnType< $mol_pop_bubble['style'] >
	>
	export class $shm_hotkey_editor extends $mol_pick {
		Card( ): $mol_view
		popup_content( ): readonly($mol_view)[]
		Message( ): $mol_view
		Status( ): $mol_view
		configure_title( ): string
		configure_hint( ): string
		Configure( ): $mol_button_minor
		Remove_icon( ): $mol_icon_trash_can
		Remove( ): $mol_button_minor
		status( ): string
		activation_label( ): string
		anchor( ): string
		Bubble( ): $mol_pop_bubble
		message( ): string
		remove_enabled( ): boolean
		remove( next?: any ): any
		configure( next?: any ): any
		sub_visible( ): ReturnType< $shm_hotkey_editor['popup_content'] >
		bubble_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=editor.view.tree.d.ts.map